import { Button } from 'antd';
import React, { useState } from 'react';
import './Invoices.css';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CustomTable from '../CustomTable';

function Invoices() {

  return (
    <div>
      <div className="startinventoryOuter">
        <div className="startinventory">
          <h4>Invoices</h4>
          <div className='buttonContainer'>
            <Button
              className='commonBtn'
              icon={<KeyboardArrowDownIcon />}
              iconPosition={'end'}
              disabled
            >
              Review & pay from
            </Button>
            <Button
              className='commonBtn'
              icon={<KeyboardArrowDownIcon />}
              iconPosition={'end'}
            >
              Other Actions
            </Button>
            <Button
              className='commonBtn'
            >
              Export as CSV
            </Button>
          </div>
          <div className='tableOuter'>
            <CustomTable
              data={[]}
              columns={[]}
              isLoading={false}

            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Invoices;
